'use strict';

var React = require('react');

var SvgGlobeMinor = function SvgGlobeMinor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M12.347 15.521c.699-1.16 1.39-2.712 1.589-4.521h1.974a6.013 6.013 0 0 1-3.563 4.521zm-8.257-4.521h1.975c.198 1.809.889 3.361 1.589 4.521a6.017 6.017 0 0 1-3.564-4.521zm3.564-6.521c-.7 1.16-1.391 2.712-1.59 4.521h-1.974a6.017 6.017 0 0 1 3.564-4.521zm.423 4.521c.269-1.916 1.239-3.52 1.925-4.443.687.92 1.655 2.519 1.922 4.443h-3.847zm1.92 6.443c-.685-.919-1.653-2.519-1.921-4.443h3.847c-.27 1.916-1.24 3.521-1.925 4.443zm5.913-6.443h-1.974c-.198-1.809-.89-3.361-1.59-4.521a6.013 6.013 0 0 1 3.564 4.521zm-5.91-7c-4.411 0-8 3.589-8 8s3.589 8 8 8c4.41 0 8-3.589 8-8s-3.59-8-8-8z"
  }));
};

exports.SvgGlobeMinor = SvgGlobeMinor;
